export const normalizeMultilineText = (
     text?: string,
     fallback = "No remarks"
    ) => {
     const cleaned = text?.split(/\r?\n/).filter(line => line.trim()).join("\n");
     return cleaned || fallback;
    };